import { Theme } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { CSSObject } from 'tss-react';
import {
  BODY1_LINE_HEIGHT,
  getResponsiveFontSize,
} from './watchdutyTheme.utils';

export const commonEditorStyles = (theme: Theme): CSSObject => ({
  '*': {
    fontFamily: theme.typography.fontFamily,
  },
  '& p': {
    fontSize: getResponsiveFontSize(theme.typography.pxToRem(16)),
    lineHeight: BODY1_LINE_HEIGHT,
  },
  '& a': {
    color: deepOrange[500],
  },
  '& li>p': {
    margin: 0,
    padding: '4px 0px',
  },
  '& ul': {
    margin: 0,
    paddingLeft: theme.spacing(2),
  },
});
